import { useState, useEffect } from "react";
import styled from "styled-components";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { colors } from "../styles/colors";

const LayoutWrapper = styled.div`
  display: flex;
  min-height: 100vh;
`;

const MainContent = styled.main`
  flex: 1;
  padding: 20px;
  background-color: ${colors.background};
  margin-left: ${({ sidebarWidth, isSidebarOpen }) =>
    isSidebarOpen ? `${sidebarWidth}px` : "0px"};
  transition: margin-left 0.3s ease-in-out;

  @media (min-width: 769px) {
    margin-left: ${({ sidebarWidth }) => `${sidebarWidth}px`};
  }
`;

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [sidebarWidth, setSidebarWidth] = useState(250);
  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    const updateSidebarWidth = () => {
      const sidebar = document.querySelector("aside");
      if (sidebar) {
        setSidebarWidth(sidebar.offsetWidth);
      }
    };

    updateSidebarWidth();
    window.addEventListener("resize", updateSidebarWidth);
    return () => window.removeEventListener("resize", updateSidebarWidth);
  }, []);

  return (
    <LayoutWrapper>
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        onMenuItems={setMenuItems}
      />
      <MainContent sidebarWidth={sidebarWidth} isSidebarOpen={isSidebarOpen}>
        <Header menuItems={menuItems} />
        {children}
      </MainContent>
    </LayoutWrapper>
  );
};

export default Layout;